export const LAYOUT_VENDOR_HOME = '/app/home'

export const LAYOUT_VENDOR_USER_ROOT = '/app/user'
export const LAYOUT_VENDOR_USER_SHOW = '/app/user/show'

export const LAYOUT_VENDOR_USER_EDIT = '/app/user/edit'

export const LAYOUT_VENDOR_JOB_ROOT = '/app/job'
export const LAYOUT_VENDOR_JOB_SHOW = (id) => `/app/job/show/${id}`

export const LAYOUT_VENDOR_TASK_ROOT = '/app/task'
export const LAYOUT_VENDOR_TASK_LIST = '/app/task/list'

export const LAYOUT_VENDOR_FINANCE_PANEL = '/app/finance/panel'

export const LAYOUT_VENDOR_QA_ROOT = '/app/qa'
export const LAYOUT_VENDOR_QA_LIST = '/app/qa/list'
